import Contact from './contact';
export default Contact;